import { registerTacticalPlugin } from "./registry";

/** Регистрация метаданных; клики/overlay ведёт хост через activePluginId === 'range-ring'. */
registerTacticalPlugin({
  id: "range-ring",
  label: "Кольцо дальности",
  description: "Клик по карте — круг заданного радиуса (overlay, не CAD-фича).",
  activate: () => {
    /* host включает click-handler по id */
    return () => undefined;
  },
});

export {};
